import type { Path, RequestUser } from 'shared-types';

interface Params {
  pathEndDate: string;
  user: RequestUser;
  userAccess: Path['userAccess'];
  userIsEnrolled: boolean;
}

const pathCanBeJoined = ({
  pathEndDate,
  user,
  userAccess,
  userIsEnrolled
}: Params) => {
  if (!user || (pathEndDate && Date.parse(pathEndDate) < Date.now())) {
    return false;
  }

  return (
    !userIsEnrolled &&
    ((user.authenticatorType !== 'guest' &&
      user.authenticatorType !== 'local' &&
      user.authenticatorType !== 'local-totp' &&
      userAccess === 'sso') ||
      userAccess === 'registered')
  );
};

export default pathCanBeJoined;
